module.exports = __webpack_public_path__ + "static/media/flickr-social-media-svgrepo-com.428d0b3b.svg";